import * as React from "react";

// plugin imports

// utils imports

// svg imports
import Pescado from "../svg/icons/allergens/pescado.svg";
import FrutosSecos from "../svg/icons/allergens/frutosSecos.svg";
import Lacteos from "../svg/icons/allergens/lácteos.svg";
import Moluscos from "../svg/icons/allergens/moluscos.svg";
import Gluten from "../svg/icons/allergens/gluten.svg";
import Crustaceos from "../svg/icons/allergens/crustáceos.svg";
import Huevo from "../svg/icons/allergens/huevo.svg";
import Cacahuetes from "../svg/icons/allergens/cacahuetes.svg";
import Soja from "../svg/icons/allergens/soja.svg";
import Apio from "../svg/icons/allergens/apio.svg";
import Mostaza from "../svg/icons/allergens/mostaza.svg";
import Sesamo from "../svg/icons/allergens/sésamo.svg";
import Altramuz from "../svg/icons/allergens/altramuces.svg";
import Sulfitos from "../svg/icons/allergens/sulfitos.svg";

export const RouteContext = React.createContext({
	location: undefined,
});

const defaultValues = {
	showAllergens: false,
	setShowAllergens: () => {},
	filterAllergens: [],
	setFilterAllergens: () => {},
	allergensList: {},
};

export const AllergensContext = React.createContext(defaultValues);

export const AllergensProvider = ({ children }) => {
	const [showAllergens, setShowAllergens] = React.useState(false);
	const [filterAllergens, setFilterAllergens] = React.useState([]);

	const allergensList = [
		{ name: "Pescado", icon: <Pescado /> },
		{ name: "Frutos Secos", icon: <FrutosSecos /> },
		{ name: "Lácteos", icon: <Lacteos /> },
		{ name: "Moluscos", icon: <Moluscos /> },
		{ name: "Gluten", icon: <Gluten /> },
		{ name: "Crustáceos", icon: <Crustaceos /> },
		{ name: "Huevos", icon: <Huevo /> },
		{ name: "Cacahuetes", icon: <Cacahuetes /> },
		{ name: "Soja", icon: <Soja /> },
		{ name: "Apio", icon: <Apio /> },
		{ name: "Mostaza", icon: <Mostaza /> },
		{ name: "Sésamo", icon: <Sesamo /> },
		{ name: "Altramuz", icon: <Altramuz /> },
		{ name: "Sulfitos", icon: <Sulfitos /> },
	]; // The names of this array must match cartaAllergens/allergenList array

	return (
		<AllergensContext.Provider
			value={{
				...defaultValues,
				showAllergens,
				setShowAllergens,
				filterAllergens,
				setFilterAllergens,
				allergensList,
			}}
		>
			{children}
		</AllergensContext.Provider>
	);
};
